"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.authReducer = exports.setCredentials = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var initialState = {
    admin_id: "",
    expires_in: 0,
    id_token: "",
    access_token: "",
    refresh_token: "",
    token_type: "",
};
var authSlice = (0, toolkit_1.createSlice)({
    name: "authSlice",
    initialState: initialState,
    reducers: {
        setCredentials: function (state, action) {
            var _a = action.payload, admin_id = _a.admin_id, expires_in = _a.expires_in, id_token = _a.id_token, access_token = _a.access_token, refresh_token = _a.refresh_token, token_type = _a.token_type;
            state.admin_id = admin_id;
            state.expires_in = expires_in;
            state.id_token = id_token;
            state.access_token = access_token;
            state.refresh_token = refresh_token;
            state.token_type = token_type;
        },
    },
});
exports.setCredentials = authSlice.actions.setCredentials;
exports.authReducer = authSlice.reducer;
